const areClientHintsAvailable = typeof navigator.userAgentData !== 'undefined';

/**
 * Load client hints module
 * @returns
 */
function loadClientHintsModule() {
  return import(/* webpackChunkName: 'chu', webpackPreload: true */ './client-hints');
}

/**
 * Load user agents module
 * @returns
 */
function loadUserAgentsModule() {
  return import(/* webpackChunkName: 'uau', webpackPreload: true */ './user-agent');
}

/**
 * Detect user browser
 * @returns
 */
export async function detectBrowser() {
  if (areClientHintsAvailable) {
    const clientHintsModule = await loadClientHintsModule();
    return clientHintsModule.detectBrowser();
  } else {
    const userAgentModule = await loadUserAgentsModule();
    return userAgentModule.detectBrowser();
  }
}

/**
 * Detect user device
 * @returns
 */
export async function detectDevice() {
  if (areClientHintsAvailable) {
    const clientHintsModule = await loadClientHintsModule();
    return clientHintsModule.detectDevice();
  } else {
    const userAgentModule = await loadUserAgentsModule();
    return userAgentModule.detectDevice();
  }
}

/**
 * Detect user OS
 * @returns
 */
export async function detectOS() {
  if (areClientHintsAvailable) {
    const clientHintsModule = await loadClientHintsModule();
    return clientHintsModule.detectOS();
  } else {
    const userAgentModule = await loadUserAgentsModule();
    return userAgentModule.detectOS();
  }
}
